// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qLSl","content":"styles_content__4izqM","row":"styles_row__2JZvk","footer":"styles_footer__1U5Hl","phraseLength":"styles_phraseLength__2J1I2"};